// extracted by mini-css-extract-plugin
module.exports = {"or":"styles_or__14IT7","inputWrap":"styles_inputWrap__2cZPY","input":"styles_input__3cKw9"};